import { render, staticRenderFns } from "./BlogShow.vue?vue&type=template&id=27e791ff&"
import script from "./BlogShow.vue?vue&type=script&lang=ts&"
export * from "./BlogShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports